import React, {useState} from 'react'

export const Atbash = ({alphabetKey, alphabet}) => {
    const [decipheredCode, setDecipheredCode] = useState('');

    let cipherDecoder = () => {
        let cipherObject = {}

        for(let i = 0; i < alphabet.length; i++) {
            cipherObject[i] = alphabet[alphabet.length - i - 1]
        }

        return cipherObject
    }

    cipherDecoder = cipherDecoder()

    const handleAtbashDecipher = (e) => {
        e.preventDefault()

        const code = e.target.atbash_code.value.toLowerCase().toString()
        let decipheredCode  = ''

        for (let i in code) {
            const letter = code[i]

            console.log(/^[a-z ]+$/.test(letter));

            if (/^[a-z]+$/.test(letter) === true) {
                let cipheredLetter = cipherDecoder[alphabetKey[letter]]

                decipheredCode += cipheredLetter
            } else {
                decipheredCode += letter
            }
        }

        setDecipheredCode(decipheredCode)
    }

    return (
        <div>
            <h2>Atbash</h2>
            <p>The Atbash cipher is used to decode words by using the alphabet backwards. Basically, A becomes Z, and Z becomes A. Another way to put it, it's the Alphabet in reverse.</p>

            <p>Insert your coded message in the box, and the decoded message will be shown beneath it.</p>

            <form action="#" onSubmit={(e)=>handleAtbashDecipher(e)}>
                <label htmlFor="atbash_code">Encoded Message</label>
                <br />
                <input name= "atbash_code" type="text" />
                <button>Decode</button>
            </form>

            {decipheredCode !== '' && <p className="results">Result: {decipheredCode}</p>}
        </div>
    )
}
